import React, { useContext, useState } from 'react';
import './styles.css';
import { Modal } from '../Modal';
import { GlobalContext } from '../../contexts/HomeContext';

export const Rodape = React.memo(function Rodape() {
  const { dadosApp } = useContext(GlobalContext);
  const [visibilityAjuda, setvisibilityAjuda] = useState('none');
  const [visibilityInfo, setvisibilityInfo] = useState('none');
  const [visibilityArea, setvisibilityArea] = useState('none');
  const [visibilityPag, setvisibilityPag] = useState('none');

  const ocultarModalPag = () => {
    setvisibilityPag(visibilityPag == 'none' ? 'block' : 'none');
  };

  const ocultarModalArea = () => {
    setvisibilityArea(visibilityArea == 'none' ? 'block' : 'none');
  };

  const ocultarModalInfo = () => {
    setvisibilityInfo(visibilityInfo == 'none' ? 'block' : 'none');
  };

  const ocultarModalAjuda = () => {
    setvisibilityAjuda(visibilityAjuda == 'none' ? 'block' : 'none');
  };
  return (
    <>
      <footer id="footer">
        <div className="wave footer"></div>
        <div className="container margin_60_40">
          {dadosApp.TipoApp === 'DELIVERY' && dadosApp.IdLoja > 0 && (
            <div className="row">
              <div
                className="col-lg-3 col-md-6"
                style={{ display: dadosApp.Qs.cardapioDigital === 'true' ? 'none' : 'block' }}
              >
                <h3 id="h3_collapse_1" data-toggle="collapse" data-target="#collapse_1">
                  Links Rápidos
                </h3>
                <div className="collapse dont-collapse-sm links" id="collapse_1">
                  <ul>
                    <li>
                      <a onClick={ocultarModalInfo}>Informações</a>
                    </li>
                    <li>
                      <a onClick={ocultarModalArea}>Área de Atendimento</a>
                    </li>
                    <li>
                      <a onClick={ocultarModalPag}>Meios de Pagamento</a>
                    </li>
                    <li>
                      <a onClick={ocultarModalAjuda}>Ajuda</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
          <div className="row add_bottom_25">
            <div className="col-lg-6"></div>
            <div className="col-lg-6">
              <ul className="additional_links">
                {dadosApp.Qs.cardapioDigital !== 'true' && (
                  <li>
                    <a href="https://garcomweb.com.br/termo/termos.php" target="_blank" rel="noreferrer">
                      Termos de Uso
                    </a>
                  </li>
                )}
                <li>
                  <span>
                    <a href="https://www.garcomweb.com.br" target="_blank" rel="noreferrer">
                      © Garçom Web
                    </a>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      {visibilityPag === 'block' && (
        <Modal
          title="Olá, Visitante"
          isFooter={true}
          visibility={visibilityPag}
          page="INFO_PAGAMENTO"
          btnOnClickClose={ocultarModalPag}
        />
      )}

      {visibilityArea === 'block' && (
        <Modal
          title="Área de Atendimento"
          isFooter={true}
          visibility={visibilityArea}
          page="AREA_ATENDIMENTO"
          btnOnClickClose={ocultarModalArea}
        />
      )}

      {visibilityAjuda === 'block' && (
        <Modal
          title="Olá, Visitante"
          isFooter={true}
          visibility={visibilityAjuda}
          page="AJUDA"
          btnOnClickClose={ocultarModalAjuda}
        />
      )}
      {visibilityInfo === 'block' && (
        <Modal
          title="Olá, Visitante"
          isFooter={true}
          visibility={visibilityInfo}
          page="INFORMACOES"
          btnOnClickClose={ocultarModalInfo}
        />
      )}
    </>
  );
});
